export default "__VITE_ASSET__B$Lnx8rJ__"